module.exports = __webpack_public_path__ + "static/img/ourAppImg2.2effe942.png";